import { REMOVE_DYNAMIC_ATTRIBUTE } from "@/modules/dynamic-attributes/entities/attribute";
import { GET_ENTITY_ATTRIBUTES } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/api/get-entity-attributes";
import { useNotification } from "@/shared/feedback/notification";
import { useMutation } from "@apollo/client";
import { useTranslations } from "use-intl";

export function useDeleteEntityAttribute() {
  const notify = useNotification();
  const t = useTranslations("EntityAttributeList");
  const [remove] = useMutation(REMOVE_DYNAMIC_ATTRIBUTE, {
    refetchQueries: [GET_ENTITY_ATTRIBUTES],
  });

  const deleteAttribute = async (id: string) => {
    await remove({
      variables: { id },
    });

    notify?.success({
      message: t("Attribute removed"),
    });
  };

  return deleteAttribute;
}
